<article
  class="tw-h-full tw-flex tw-items-center tw-gap-4 tw-rounded tw-border tw-border-gray-300 tw-bg-white tw-p-2 sm:tw-p-4 2xl:tw-p-6"
>
  <span
    class="tw-rounded-full tw-bg-purple-100 tw-p-1 md:tw-p-2 tw-text-apicuron-purple tw-shrink-0 tw-self-start"
  >
    <svg-icon
      [src]="iconSrc"
      svgClass="tw-w-10 tw-h-10 tw-fill-apicuron-purple"
    ></svg-icon>
  </span>

  <div>
    <p class="tw-text-xl tw-font-semibold tw-text-apicuron-purple">{{ value }}</p>

    <p class="tw-py-1 tw-text-sm tw-font-bold tw-text-gray-700">{{ label }}</p>

    <p class="tw-text-xs tw-text-gray-500">{{ description }}</p>
  </div>
</article>
